import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { c } from '@debbie/cortex/dist/index.js';
import { selectCaseById } from '@debbie/cortex/dist/cases/selectors.js';
import { CasePreview, PlaceholderLoader } from '../index.js';
const CasePreviewByCaseId = (props) => {
    const singleCase = useSelector((s) => selectCaseById(s, props.caseId));
    useEffect(() => {
        loadCases();
    }, []);
    const loadCases = () => {
        if (!singleCase) {
            c.cases.getById(props.caseId);
        }
    };
    return singleCase ? (React.createElement(CasePreview, { ...props, caseId: singleCase.id })) : (React.createElement(PlaceholderLoader, null));
};
export default CasePreviewByCaseId;
//# sourceMappingURL=CasePreviewByCaseId.js.map